<footer class="usa-footer">
  <button
    class="semantic-button return-to-top-row"
    id="scrollBar"
    title="Go to top"
    (click)="topFunction()"
  >
    Return to top
  </button>
  <div class="links-row">
    <a [href]="link.route" class="footer-link" *ngFor="let link of links">
      {{ link.text }}
    </a>
  </div>
  <div class="footer-body">
    <div class="footer-brand">
      <div class="usa-footer-logo-img">
        <img
          alt="USDA logo. Forest Service Logo."
          class="mobile"
          src="/assets/img/usda/footer-logo-mobile.png"
        />
        <img
          alt="USDA logo. Forest Service Logo. Forest Service U.S. Department of Agriculture"
          class="desktop"
          src="/assets/img/usda/usda-fs-logo.png"
        />
      </div>
      <p class="version-text">
        <a [routerLink]="'/help/info/version-history'">{{ versionInfoString }}</a>
      </p>
    </div>

    <div class="social-icons">
      <a
        *ngFor="let social of socialLinks"
        class="social-icon"
        [href]="social.route"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img [src]="social.icon" [alt]="social.name" />
      </a>
    </div>

    <div class="footer-contact">
      <p class="contact-line">
        <strong>For help, go to:</strong>
        <a class="link" [routerLink]="'/help'">CIAO Help Center</a>
        <span class="divider" aria-hidden="true">|</span>
        <a
          class="link"
          href="https://usdacts-myit.fed.onbmc.com/dwp/app/#/"
          rel="noopener noreferrer"
          target="_blank"
          >FS Help Desk</a
        >
      </p>
      <p class="contact-line">
        <strong>Send feedback to:</strong>
        <a class="link" href="mailto:sm.fs.ciao_feedback@usda.gov">CIAO</a>
      </p>
    </div>
  </div>
</footer>
